// AssistantIconButton — THE icon button of the assistant's chrome: the
// header actions (settings, dock, minimize, close) and the composer bar
// (upload, voice, settings). One primitive, one geometry, one set of states
// (Rule 65 / Rule 68 — the scale belongs here, never to a call site).
//
// Before this (2026-09-10 per Nika "fix ui and alignment in ai assistant —
// make design way more beautiful"): the header buttons were NavbarButtons at
// `padding: 'Y2'` (35px, 17px glyphs), the composer's were the same base at
// `padding: 'Y'` (27px, 15px glyphs), and the send button was a 38px circle
// — three sizes, three centre lines, in one panel.
//
// Brand grammar (brand-language, chrome register): a `controlHCompact` (36px)
// circle on `radiusPill`, the glyph at `iconMd` (20px), quiet `inactive` ink
// that steps to `title` on approach, the house `hover` wash (a fill step,
// never opacity), `selected` when pressed. Monochrome — hue never marks a
// chrome button. The tap-slop pseudo for touch is inherited from NavbarButton.
export const AssistantIconButton = {
  extends: ['NavbarButton', 'AppControl'],
  compact: true,
  boxSize: 'controlHCompact',
  minWidth: 'controlHCompact',
  boxSizing: 'border-box',
  padding: '0',
  round: 'radiusPill',
  align: 'center center',
  flexShrink: '0',
  theme: 'transparent',
  border: 'none',
  color: 'inactive',
  cursor: 'pointer',
  transition: 'A defaultBezier',
  transitionProperty: 'background-color, color',
  ':hover': { background: 'hover', color: 'title' },
  ':active': { background: 'selected', color: 'title' },
  Icon: { boxSize: 'iconMd', display: 'block', flexShrink: '0' }
}
